// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"34":"application","328":"admin"}[chunkId] + "-" + {"34":"84cdfc1b","328":"508be4fe"}[chunkId] + ".css";
};